import { render, staticRenderFns } from "./BatterySolution.vue?vue&type=template&id=0b06afd5&scoped=true&"
import script from "./BatterySolution.vue?vue&type=script&lang=js&"
export * from "./BatterySolution.vue?vue&type=script&lang=js&"
import style0 from "./BatterySolution.vue?vue&type=style&index=0&id=0b06afd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06afd5",
  null
  
)

export default component.exports